import React, { memo } from 'react';

import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import Table from '../../Table';

import ReportService from '../../../services/ReportService';
import createInvoiceScheduleTableCell from '../../../helpers/tables/createInvoiceScheduleTableCell';

// const createLinkToInvoice = (row) =>
// `/loans/${row?.loan_id}/invoices/${row?.id}?tab=Invoice`;

// const createLinkToProperty = (row) => `/loans/${row?.loan_id}?tab=Property`;

const formatDate = (date) => moment(date).format('MM/DD/YYYY');

function PaymentsDueTable() {
  const { t } = useTranslation();

  const { data: paymentsDue } = useQuery({
    queryKey: ['paymentsDue'],
    queryFn: ReportService.getPaymentsDue,
    onError: (error) => {
      console.log('Error getting due payments:', error);
    },
  });

  const cols = [
    {
      title: t('common.tables.columns.Due date'),
      keys: ['date'],
      //   link: createLinkToInvoice,
      format: formatDate,
    },
    {
      title: t('common.tables.columns.Late date'),
      keys: ['date_overdue'],
      //  link: createLinkToInvoice,
      format: formatDate,
    },
    {
      title: t('common.tables.columns.Schedule'),
      keys: ['scheduled_payments'],
      format: createInvoiceScheduleTableCell,
      //  link: createLinkToInvoice,
    },
    {
      title: t('common.tables.columns.Invoice number'),
      keys: ['pixel_invoice_number'],
      // link: createLinkToInvoice,
    },
    {
      title: t('common.tables.columns.Status'),
      keys: ['status'],
      //  link: createLinkToInvoice,
    },
    {
      title: t('common.tables.columns.Total'),
      keys: ['_amount.invoice_total'],
      type: 'currency',
      // link: createLinkToInvoice,
    },
    {
      title: t('common.tables.columns.Paid'),
      keys: ['_paid.amount_paid'],
      //  link: createLinkToInvoice,
      type: 'currency',
    },
    {
      title: t('common.tables.columns.Property'),
      keys: ['_loan._property.address_line_1'],
      // link: createLinkToProperty,
    },
  ];

  return (
    <div>
      <Table
        cols={cols}
        rows={paymentsDue}
        title={t('Dashboard.PaymentsDueTable.Payments Due')}
      />
    </div>
  );
}

export default memo(PaymentsDueTable);
